import emoji from "emoji-dictionary"
import CodeFormatter from './CodeFormatter'
import DomPurify from "dompurify"
import { fs } from "../controls/Constants";

interface codeArticle {
    codeSignature: string | null;
    codeUsage: string | null;
    data: Array<string>;
    index: string;
    intro: string | null;
    other: string | null;
}
const CodeArticle = ({codeSignature, codeUsage, data, index, intro, other}: codeArticle) => {
    return (
        <article>
                    <h3>{emoji.getUnicode(index)} {intro}</h3>
                    {codeSignature && <CodeFormatter 
                    codeSnippet={codeSignature}
                    />}
                    <h3>Description:</h3>
                    <ul className={`${fs}`}>
                        {
                            data.map((item, index) => <li key={index} 
                            dangerouslySetInnerHTML={{__html: DomPurify.sanitize(item)}}
                            /> )
                        }
                    </ul>
                    {codeUsage &&<h3>{emoji.getUnicode("bulb")} Example Usage:</h3>}
                    {codeUsage && <CodeFormatter
                    codeSnippet = {codeUsage}
                    />
                    }
                    {other && <p>
                        {emoji.getUnicode("small_blue_diamond")}  
                        <span dangerouslySetInnerHTML={{__html: DomPurify.sanitize(other)}}/>
                        </p>}
                </article>
    )
}

export default CodeArticle
